import { FC, MouseEvent, useEffect, useRef, useState } from 'react';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { ClickAwayListener } from '@mui/material';
import { DummySpan, TextFieldTag } from './styles';
import { StyledChip } from '@/components/Tag/styles';

interface TagProps {
  label: string;
  isEditing?: boolean;
  setEditTagId?: (tagId: number | null) => void;
  handleOpenMenu: (event: MouseEvent<HTMLDivElement>, tagId?: string) => void;
  saveEdit?: (newLabel: string) => void;
}

const Tag: FC<TagProps> = ({ label, isEditing, setEditTagId, handleOpenMenu, saveEdit }) => {
  const [editedLabel, setEditedLabel] = useState(label);
  const spanRef = useRef<HTMLSpanElement>(null);
  const [inputWidth, setInputWidth] = useState(label.length * 8 + 8);

  const handleClickAway = () => {
    if (isEditing && setEditTagId) {
      if (saveEdit && editedLabel !== label) saveEdit(editedLabel);
      setEditTagId(null);
    }
  };

  useEffect(() => {
    if (spanRef.current) {
      setInputWidth(spanRef.current.offsetWidth + 8);
    }
  }, [editedLabel]);

  return isEditing ? (
    <>
      <ClickAwayListener onClickAway={handleClickAway}>
        <TextFieldTag
          size="small"
          autoFocus
          defaultValue={label}
          hiddenLabel
          onChange={(e) => setEditedLabel(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleClickAway()}
          style={{ width: `${inputWidth}px` }}
        />
      </ClickAwayListener>
      <DummySpan ref={spanRef}>{editedLabel}</DummySpan>
    </>
  ) : (
    <StyledChip icon={<LocalOfferOutlinedIcon />} label={label} size="small" onClick={handleOpenMenu} />
  );
};

export default Tag;
